import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams,HttpResponse } from '@angular/common/http';
//import * as CryptoJS from 'crypto-js';
import { CommonService } from './../common.service';
import { CommonVariablesService } from './../common-variables.service';
import { NgxSpinnerService } from "ngx-spinner";
import {Md5} from 'ts-md5/dist/md5';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit 
{
	//@ViewChild('captchaRef', { static: false })  captchaElem1: RecaptchaModule;
	loginForm: FormGroup;
	submitted = false;
	response: any;
	profileurl: any;
	parameter: any;
	param: any;
	allGroupData:any;
	checkCaptcha = false;
	showCaptcha = false;
	incorrectPwdCount = 0;
	loginCount = 0
	newUrl:boolean=true;
	currentURL:any;
	profileResponse: HttpResponse<HttpClient>;
	public sitekey: string = "6LestNwZAAAAAF0jT-YI5Ay1jrA6CdrcwqPfBMBv";
	public secretkey: string = "6LestNwZAAAAALc0QtEkUtFf0zz407gyoy4bKEQ3";
	
	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private http: HttpClient,
		private commonService: CommonService,
		private commonVariablesService: CommonVariablesService,
		private spinner: NgxSpinnerService,
		
		/* private _md5: Md5 */
	) { this.currentURL = window.location.href; 
		console.log("this.currentURL",this.currentURL)
		if(this.currentURL == "https://emarinedeclhub.tataaig.com/marine/#/login"){
			this.newUrl = false;
		}else{
			this.newUrl = true;
		}
    }

	ngOnInit() {
		console.log("this.url",this.newUrl)
		window.localStorage.setItem('pageName','');
		this.spinner.show();
		this.loginForm = this.formBuilder.group({
			username: [  "" , Validators.required],
			password: ["", Validators.required],
			userLogin: [ "", Validators.required],
			recaptcha: ""
		});

		this.loginForm.patchValue({ userLogin: 'Producer/Client' });
		let recaptchaCount = Number(sessionStorage.getItem('recaptcha'));
		
		if(recaptchaCount >= 3){
			this.showCaptcha = true;
			this.loginForm.get('recaptcha').setValidators([Validators.required])
		}
		else
			this.loginForm.get('recaptcha').clearValidators()
		this.loginForm.get('recaptcha').updateValueAndValidity();
	}
	ngAfterViewInit() {
		setTimeout(() => {
			this.spinner.hide();
		}, 1000);
	}
	
	get f() { return this.loginForm.controls; }

	 handleExpire() {
		this.checkCaptcha = false;
	}
	handleLoad() {
		this.checkCaptcha = false;
	}
	handleSuccess(event: any) {
		this.checkCaptcha = true;
	}

	RedirectToNew() {
		this.spinner.show();
			var username = this.loginForm.controls.username.value;
			var pwd = Md5.hashStr(this.loginForm.controls.password.value);
			// redirection from old to new
			 window.location.href =  (this.commonVariablesService.baseURL + 'emarine/#/login?email='+ username + 'password='+ pwd)
	}

	/*
	* Created By : Keerthana
	* Description : This function is used to login the application.
	*********************************************/

	async onSubmit() 
	{
		this.submitted = true;
		if (this.loginForm.invalid) 
		{
			return;
		}
		/* sessionStorage.setItem('recaptcha','0'); */
		if (this.loginForm.value.userLogin == "Producer/Client") 
		{

			var url;
			
			// this.spinner.show();

			var username = this.loginForm.controls.username.value
			// /* var pwd = this.loginForm.controls.password.value; */
			var pwd = Md5.hashStr(this.loginForm.controls.password.value);
			url = this.commonVariablesService.baseURL + 'api/v1/auth';

			this.parameter = {
					email: username,
				mpwd: pwd
			}

			var authResponse = await this.commonService.httpPostMethod(url, this.parameter, 'application/json', false, 'Login');

			if (authResponse.body.status == 0) 
			 {

				this.RedirectToNew();
			// 	window.localStorage.setItem('token', authResponse.body.data.token);
			// 	/* this.cookie.set('token', authResponse.body.data.token) */
			// 	sessionStorage.setItem('token', authResponse.body.data.token);
			// 	/* this.cookie.set('auth', this.commonService.encryptData(authResponse.body.data.token)); */
			// 	window.localStorage.setItem('auth', this.commonService.encryptData(authResponse.body.data.token));
			// 	this.param = {
			// 					'email': username,
			// 					'pwd': Md5.hashStr(this.loginForm.controls.password.value),
			// 				 }

			// 	url = this.commonVariablesService.baseURL + 'api/v1/profile';
			// 	this.response = await this.commonService.httpGetMethod(url, 'application/json', true, '', 'Login');

			// 	if (this.response.status == 0) 
			// 	{
			// 		window.localStorage.setItem('name', this.response.data.data.name);
			// 		window.localStorage.setItem('email', this.response.data.data.email);
			// 		window.localStorage.setItem('userType', this.commonService.encryptData('Producer/ClientUser'));
			// 		window.localStorage.setItem('lastLogin', this.response.data.last_login);
			// 		window.localStorage.setItem('systemTime', this.response.data.system_datetime);
			// 		url = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/lastlogin`;
			// 		this.http.post(url, '',{
			// 				headers: {
			// 					'in-auth-token': sessionStorage.getItem('token')
			// 				}, observe: 'response',
			// 			}).subscribe(async (res: any) => {
			// 			setTimeout(() => {
			// 				this.spinner.hide();
			// 			}, 1000);
			// 			/* if (res.body.data.status == 0) {
			// 			} */
			// 		});
			// 		await this.commonService.commonLOBvalues();
			// 		if (this.response.data.is_broker == 1 || (this.response.data.roles.indexOf('R000000000004') > -1)) 
			// 		{
			// 			this.commonService.tokenExpiredCount = 0;
			// 			url = this.commonVariablesService.baseURL+'api/v1/marine_user_management/broker_user';
			// 			let param={
			// 				email_id:this.response.data.data.email,
			// 				product:this.commonVariablesService.user_management_product
			// 			}
			// 			let response = await this.commonService.httpPostMethod(url, param,'application/json', true, 'Login');
			// 			if(response.body.status==0){
			// 				if(response.body.data.length > 0){
			// 					const ret = this.commonVariablesService.productId ? true : await this.commonService.commonLOBvalues();
			// 					if (!ret) return;
			// 					await this.commonService.formMasterPolicyList('Header');
			// 					let pageId = 0;
			// 					if (this.commonService.gcPolicyList.length == 1) {
			// 						pageId = 1;
			// 						await this.commonService.setCertificateParmsToLStorage({
			// 							value: this.commonService.gcPolicyList[0].search_val,
			// 							item: this.commonService.gcPolicyList[0]
			// 						});
			// 					}
			// 					this.commonService.passValue({ id: pageId });
			// 					this.router.navigate(['/declaration/'+pageId]);
			// 					window.localStorage.setItem('userProfile', this.commonService.encryptData((response.body.data[0].broker_user_type == "ClientUser") ? 'clientUser' : 'producerUser'));
			// 				}
			// 				else{
			// 					this.commonService.errorsmsg('No data for broker user type','');
			// 					return
			// 				}
			// 			}else{
			// 				this.commonService.errorsmsg(response.body.txt,'');
			// 				return
			// 			}
			// 			//this.router.navigate(['/declaration/0']);
			// 		}

			// 		// QandA login
			// 		/*  else if (this.response.data.is_admin == 1 || (this.response.data.roles.indexOf('R000000000001') > -1)) {
			// 			this.commonService.tokenExpiredCount = 0;
			// 			this.router.navigate(['/master-policy-complete']);
			// 			this.cookie.set('userProfile', this.commonService.encryptData('admin'));
			// 		} */ 

			// 		else 
			// 		{
			// 			this.commonService.errorsmsg('Invalid User', 'Error');
			// 		}
			// 	}
			// 	else 
			// 	{
			// 		if (this.response.status == -104) 
			// 		{
			// 			this.commonService.errorsmsg('Invalid User', 'Error');
			// 		}
			// 		else 
			// 		{
			// 			this.commonService.errorsmsg(this.response.sub, 'Error');
			// 		}
			// 	}
			}
			else 
			{
				if (authResponse.body.status == -101) 
				{
					this.commonService.errorsmsg('User name / Password does not match', 'Error');
					this.incorrectPwdCount++;
					sessionStorage.setItem('recaptcha',this.incorrectPwdCount+'');
				}
				else 
				{
					this.commonService.errorsmsg(authResponse.body.txt, 'Error');
				}
			}
			// let recaptchaCount = Number(sessionStorage.getItem('recaptcha'));
			// if(recaptchaCount >= 3){
			// 	this.showCaptcha = true;
			// 	this.loginForm.get('recaptcha').setValidators([Validators.required])
			// }
			// else
			// 	this.loginForm.get('recaptcha').clearValidators()
			// this.loginForm.get('recaptcha').updateValueAndValidity();
			// this.resetLoginform();
		}
		else 
		{
			this.spinner.show();
			this.profileurl = this.commonVariablesService.baseURL + "api/v1/profile";
			/* let md5 = Md5.hashStr(this.loginForm.value.password).toString(); */
			let md5 = this.loginForm.value.password;
			/* sessionStorage.setItem('recaptcha','0'); */
			this.loginCount = 0;
			let getToken = '';
			let param = {
				'email': this.loginForm.value.username,
				'pwd': md5,
			}
			for(let i=0;i<5;i++)
			{
				await this.commonService.profileLogin(this.profileurl,param).then((respons: HttpResponse<HttpClient>) =>{
					this.profileResponse=respons;
					getToken=respons.headers.get('set-in-auth-token');
				});
				if(!!getToken)
				{
					break;
				}else{
					this.loginCount++;
				}
			}
			let res:any = this.profileResponse;
			/* let recaptchaCount = Number(sessionStorage.getItem('recaptcha')) */
			if(this.loginCount >= 5){
				this.spinner.hide();
				this.commonService.errorsmsg('Unable to Login', 'Error');
				return;
			}
			if (res.body.status == 0) 
			{
				getToken = res.headers.get("set-in-auth-token");
				if(getToken){
					/* this.cookie.set('token', getToken) */
					sessionStorage.setItem('token', getToken);
					window.localStorage.setItem('auth', this.commonService.encryptData(getToken));
					/* this.cookie.set('auth', this.commonService.encryptData(getToken)) */
					window.localStorage.setItem('userType', this.commonService.encryptData('tagicUser'))
					window.localStorage.setItem('lastLogin', res.body.data.last_login)
					window.localStorage.setItem('systemTime', res.body.data.system_datetime)
					window.localStorage.setItem('name', res.body.data.name)
					window.localStorage.setItem('email', res.body.data.email)
					url = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/lastlogin`;
					await this.http.post(url, '',{
							headers: {
								'in-auth-token': sessionStorage.getItem('token')
							}, observe: 'response',
						}).subscribe(async () => {
						setTimeout(() => {
							this.spinner.hide();
						}, 1000);
					});
					await this.commonService.commonLOBvalues();
					
					if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_admin.toLowerCase())
					{
						this.commonService.tokenExpiredCount = 0;
						this.router.navigate(['/master-policy-complete']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('admin'));
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_claims.toLowerCase())
					{
						this.commonService.tokenExpiredCount = 0;
						//this.router.navigate(['/soa/simple-statement-of-accounts']);
						this.commonService.passValue({ id: 0 });
						this.router.navigate(['/declaration/0']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('marineclaims'));
					}
					else if (res.body.data.is_underwriter == 1 || res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_uw.toLowerCase()) 
					{
						let location = res.body.data.data.locations;
						window.localStorage.setItem('locations', this.commonService.encryptData(location));
						window.localStorage.setItem('userProfile', this.commonService.encryptData('underwriter'));
						let level = '';
						let successCount = 0;
						let uwLevelObj = {};
						this.spinner.show();
						const invalid: any = await this.getUwDetails(location).then(async (data: any) => {
							level = (((data || [])[0] || '').level || '') ? `${(((data || [])[0] || '').level || '')}` : '';
							if (level == '-1') {
								this.spinner.hide();
								this.commonService.errorsmsg('Server error', '');
								setTimeout(() => {
									this.spinner.hide();
								}, 2000);
								return true;
							}
							if (level != '' && level != '-1') {
								for(const obj of data)
								{
								uwLevelObj[obj.location.toUpperCase()] = obj.level;
								successCount += 1;
								}
								return false;
							}
						}, (err) => {
							setTimeout(() => {
								this.spinner.hide();
							}, 2000);
							return true;
						});
						if (successCount == 0 || level == '-1') {
							this.commonService.errorsmsg(level == '-1' ? 'Server error' : res.txt || 'Unable to get underwriter level', '');
							setTimeout(() => {
								this.spinner.hide();
							}, 2000);
							return;
						}
						this.spinner.hide();
						window.localStorage.setItem('uwLevelObj', JSON.stringify(uwLevelObj));
						this.commonService.tokenExpiredCount = 0;
						this.commonService.passValue({ id: 0 });
						this.router.navigate(['/declaration/0']);
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_hub.toLowerCase()) 
					{
						this.commonService.tokenExpiredCount = 0;
						this.router.navigate(['/master-policy-complete']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('hub'));
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_helpdesk.toLowerCase()) 
					{
						this.commonService.tokenExpiredCount = 0;
						this.commonService.passValue({ id: 0});
						this.router.navigate(['/declaration/0']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('helpdesk'));
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_sales_rm.toLowerCase()) 
					{
						this.commonService.tokenExpiredCount = 0;
						this.commonService.passValue({ id: 0 });
						this.router.navigate(['/declaration/0']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('rm'));
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.roles_ops.toLowerCase()) 
					{
						this.commonService.tokenExpiredCount = 0;
						this.commonService.passValue({ id: 0 });
						this.router.navigate(['/declaration/0']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('ops'));
					}
					else if (res.body.data.data.role.toLowerCase() == this.commonVariablesService.role_adminview.toLowerCase()) 
					{
						this.commonService.tokenExpiredCount = 0;
						this.router.navigate(['/master-policy-complete']);
						window.localStorage.setItem('userProfile', this.commonService.encryptData('adminview'));
					}
					else 
					{
						this.commonService.errorsmsg('Invalid User', 'Error');
					}	
				}					
			}
			else 
			{
				if (res.body.status == -106) 
				{
					this.commonService.errorsmsg('Invalid User / Credentials', 'Error');
				}
				else if(res.body.status == -101){
					this.incorrectPwdCount++;
					sessionStorage.setItem('recaptcha',this.incorrectPwdCount+'');
				}
				else {
					this.commonService.errorsmsg(res.body.sub, 'Error');
				}
			}
			let recaptchaPwdCount = Number(sessionStorage.getItem('recaptcha'));
			if(recaptchaPwdCount >= 3){
				this.showCaptcha = true;
				this.loginForm.get('recaptcha').setValidators([Validators.required])
			}
			else
				this.loginForm.get('recaptcha').clearValidators()
			this.loginForm.get('recaptcha').updateValueAndValidity();
			this.resetLoginform();
		}
			
	}

	/*
	* Created By : Keerthana
	* Description : This function is used to get the forget password mail.
	*********************************************/

	async forgotPassword() 
	{
		/* var url = this.commonVariablesService.baseURL + 'api/v1/auth/forgot'; */
		var url = this.commonVariablesService.baseURL + 'api/v1/marine_forgot_pwd/forgot';
		var parameter= {
			email: this.loginForm.controls.username.value
		};
		var response = await this.commonService.httpPostMethod(url, parameter, 'application/json; charset=UTF-8', false, 'Login')

		if (response.body.status == 0) 
		{
			this.commonService.successmsg('Confirmation mail has been sent to the email address "' + this.loginForm.controls.username.value + '". Please follow the instructions to reset your password.','Success');
		}
		else 
		{
			this.commonService.errorsmsg(response.body.txt,'Error');
		}
	}

	/*
	* Created By : Keerthana
	* Description : This function will reset the form.
	*********************************************/

	resetLoginform() 
	{
		this.loginForm.reset();
		this.submitted = false;
		//grecaptcha.reset();
		this.loginForm.patchValue({ userLogin: 'Producer/Client' });
	}
	
	
	/*
	* Created By : Sharann
	* Description : to get underwriter user level.
	*********************************************/
	async getUwDetails(location) {
		/* const mailID = this.cookie.get('email'); */
		const mailID = window.localStorage.getItem('email');
		const url = `${this.commonVariablesService.baseURL}api/v1/marine_declaration/userLevel`;
		/* const myheader = new HttpHeaders().set('in-auth-token', sessionStorage.getItem('token')); */
		const myheader = new HttpHeaders().set('in-auth-token',sessionStorage.getItem('token'));
		let body = new HttpParams();
		body = body.set('product', this.commonVariablesService.user_management_product);
		body = body.set('email_id', mailID);
		body = body.set('location', location);
		return new Promise(async resolve => {
			await this.http.post(url, body, {
				headers: myheader,
			}).subscribe(async (res: any) => {
				if (res.status == 0 && res.data.length) {
					// return await res.data;
					resolve(res.data);
				} else {
					setTimeout(() => {
						this.spinner.hide();
					}, 5000);
					resolve([]);
				}
			}, error => {
				setTimeout(() => {
					this.spinner.hide();
				}, 5000);
				resolve([{ level: '-1' }]);
			});
		});
	}
	
	hideCaptcha(){
		this.showCaptcha = false;
		this.incorrectPwdCount = 0;
		sessionStorage.setItem('recaptcha','0');
		this.loginForm.get('recaptcha').clearValidators()
		this.loginForm.get('recaptcha').updateValueAndValidity();
	}
	
	/*
	* Created By : Sharann N
	* Description : navigate to verification certificate page.
	*********************************************/
	async goToEncryptPdfPage() {
		sessionStorage.removeItem('token');
		this.router.navigate(['/encrypt-pdf']);
	}
}
